import {
  CardIcon,
  CheckMoneyIcon,
  CheckRounIcon,
  DashboardIcon,
  EmailIcon,
  MoneyIcon,
  NfcIcon,
  ResizeIcon,
  SmileIcon,
  SplitIcon,
  TableIcon,
  WalletIcon,
} from '@/public/icons';
import image0 from '@/public/payyment_processing/payment0.webp';
import image1 from '@/public/payyment_processing/payment1.webp';
import image1Desc from '@/public/payyment_processing/payment1Desc.webp';
import image2 from '@/public/payyment_processing/payment2.webp';
import image3 from '@/public/payyment_processing/payment3.webp';
import image4 from '@/public/payyment_processing/payment4.webp';

const whatIs0 = {
  title: 'Payment processing',
  subTitle:
    'We provide a single source payment solution that will allow you to streamline the way you accept and manage payments, allowing you to spend less time reconciling transactions and more time growing your business. With additional features like next day funding and reduced processing fees, this is an offer you won’t want to miss out on.',
  secondaryText:
    ' Even better, our technology leverages ways to reduce transaction costs, so you can rest assured knowing you are receiving the lowest possible rate each time you process a payment',
  items: [],
  image: {
    imageMob: image0.src,
    imageDesk: image0.src,
    height: 'auto',
  },
};

const whatIs1 = {
  title: 'Transparent pricing',
  subTitle:
    'Orcatec allows you to enjoy transparent and exclusive Interchange Plus pricing to see exactly what you are charged each month, and you only pay for what you use.',
  items: [
    {
      title:
        'Simplified Acceptance: Manage your business and process payments within one platform',
      icon: DashboardIcon,
    },
    {
      title: 'Easy Reconciliation: Never enter a transaction twice again',
      icon: WalletIcon,
    },
    {
      title:
        'Transparent Pricing: Save between 10 and 40% on your monthly processing fees',
      icon: MoneyIcon,
    },
    {
      title: 'Next Day Funding: You’ll never wait to get paid again',
      icon: CardIcon,
    },
  ],
  image: {
    imageMob: image1.src,
    imageDesk: image1Desc.src,
  },
};

const whatIs2 = {
  title: 'Online payment',
  subTitle:
    'Collect payments with ease anytime, anywhere with Orcatec all-in-one payment solution.',
  items: [
    {
      title: 'Send invoices effortlessly from the office or on the go',
      icon: EmailIcon,
    },
    {
      title: 'Split balances and offer customers multiple payment options',
      icon: SplitIcon,
    },
    {
      title: 'Get paid for your jobs in the field',
      icon: MoneyIcon,
    },

    {
      title:
        'Utilize our small compact EMV and NFC card reader in the field for secure in person payments',
      icon: NfcIcon,
    },
  ],
  image: {
    imageMob: image2.src,
    imageDesk: image2.src,
  },
};

const whatIs3 = {
  title: 'Make tipping easy',
  subTitle: `Elevate your service experience by offering clients to show their appreciation and support your team's success hassle-free.`,
  items: [
    {
      title: 'Let clients leave tips directly through our platform',
      icon: CheckMoneyIcon,
    },
    {
      title: 'Easily reward your dedicated staff with these tips',
      icon: WalletIcon,
    },
    {
      title: `Include tips automatically in workers' payouts`,
      icon: CheckRounIcon,
    },
  ],
  image: {
    imageMob: image3.src,
    imageDesk: image3.src,
  },
};
const whatIs4 = {
  title: 'What is interchange fees',
  subTitle: `Whenever you buy something with credit card, four parties are involved: You, your bank, the retailer you buy from, and the retailer’s bank. Both banks perform a series of steps to ensure your payment is processed and transferred securely, and it reaches the retailer promptly. `,
  secondaryText: `When your bank sends your payment to the retailer’s bank (known as the acquiring bank), a small fee is retained. This is called the interchange fee. Payment processors (Visa, Mastercard, American Express, and Discover) set fees once per year, usually, it is a percent together plus fixed amount. Fees depend on the type of card and method of charge: POS terminal or keyed-in.`,
  thirdText: `Then, PCI-compliant merchants like Clover Connect have their fees that are summed up with payment systems. For example, a card that is linked to fee program "CPS/e-Commerce Preferred Retail, Prepaid" has a fee 1.75% + $0.20 from the transaction.`,
  fouthText: `Clover Connect's fee is 0.4%, so the total fee for the transaction for this type of card will be 2.05% + $0.20 in case of the swiped transaction from the total amount. You can check actual interchange fees on the official website of payment system: Visa, Mastercard, American Express, Discover.`,
  items: [],
  image: {
    imageMob: image4.src,
    imageDesk: image4.src,
  },
};

const cards = [
  {
    title:
      'Seamlessly manage your business and securely accept payments, all directly within our Orcatec software',
    icon: ResizeIcon,
  },
  {
    title:
      'Security features like fraud detection and tokenization provide the ultimate data breach protection',
    icon: SmileIcon,
  },
  {
    title:
      'Personalized customer support ensures quick and easy solutions to your questions and issues',
    icon: TableIcon,
  },
];

export { whatIs0, whatIs1, whatIs2, whatIs3, cards, whatIs4 };
